
// $(window).scroll(function() {
    
//     // calculate the percentage the user has scrolled down the page
//     var scrollwin = $(window).scrollTop();
//     var articleheight = $('.blog-detail-content').outerHeight(true);
//     var windowWidth = $(window).width();
//     if(scrollwin >= $('.blog-detail-content').offset().top){
//         if(scrollwin <= ($('.blog-detail-content').offset().top + articleheight)){
//         $('.blog-reading-progress').css('width', ((scrollwin - $('.blog-detail-content').offset().top) / articleheight) * 100 + "%"  );
//         $('.blog-reading-progress').css('transform',"translateY(0)");
//         }else{
//             $('.blog-reading-progress').css('width',"100%");
            
//             if(scrollwin > ($('.blog-detail-content').offset().top + articleheight)){
//               $('.blog-reading-progress').css('transform',"translateY(100%)");
//             }
  
//             else {
//               $('.blog-reading-progress').css('transform',"translateY(0)");
//             }
//         }
//     }else{
//         $('.blog-reading-progress').css('width',"0px");
//     }
    
    
//   });